export default {
  form: {
    amount: {
      label: 'Prezzo',
    },
    threshold: {
      label: 'Vendite mensili',
    },
    has_pricing_tiers: {
      label: 'Il prezzo varia in base alle vendite mensili',
    },
    tax_included: {
      label: 'Tassa inclusa',
    },
  },
  buttons: {
    add_tier: 'Aggiungi fascia',
  },
};
